<template>
  <v-container fluid mx-0 pa-0>
    <v-row v-if="!B_Loaded" style="max-width:98%;margin:0px auto">
      <div style="width:100px;margin:0px auto">
        <v-img src="../../assets/equiload.gif" aspect-ratio="1"></v-img>
      </div>
    </v-row>
    <v-row v-if="B_Loaded" style="max-width:98%;margin:0px auto">
      <v-col cols="12" md="6" lg="4">
        <v-textarea v-model="T_TextIntro" rows="8" label="Texte d'introduction" hint="Texte ajouté en pièce jointe du mail" @change="Fct_ModifyTextIntro"></v-textarea>
        <v-text-field v-model="T_MailObject" :counter="50" label="Objet du mail" @change="Fct_ModifyMailObject" required></v-text-field>
        <v-textarea class="my-2" rows="20" v-model="T_MailBody" label="Corps du mail" hint="Contenu du mail" @change="Fct_ModifyMailBody" required></v-textarea>
        <!--<v-file-input 
            v-model="O_FileTermsConditions"
            label="Conditions générales" 
        ></v-file-input>
        <v-row> 
          <v-spacer />
          <v-btn class="mb-4" color="secondary" @click="Fct_AddFileTC" hint="Ajouter les conditions générales">Ajouter</v-btn>
          <v-btn class="mb-4 ml-4" v-if="T_FileTermsConditions != ''" color="primary" @click="Fct_ViewFileTC" hint="Voir les conditions générales">Voir</v-btn>
        </v-row>-->
      </v-col>
      <v-col cols="12" md="0" lg="1"></v-col>
      <v-col cols="12" md="6" lg="4">
        <div>
          <v-row>
            <v-select v-model="T_AdrArdentes" :items="TT_ArdArdentes" label="Adresse de livraison" style="max-width:50%;" @change="Fct_SelectAdrLiv"></v-select>
            <v-btn class="mx-1 ml-8 mt-4" fab dark x-small @click="Fct_AddAdresse" color="primary" hint="Ajouter">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
            <v-btn v-show="T_AdrArdentes" class="mx-1 mt-4" fab dark x-small @click="Fct_ModAdresse" color="primary" hint="Modifier">
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
            <v-btn v-show="T_AdrArdentes" class="mx-1 mt-4" fab dark x-small @click="Fct_DelAdresse" color="primary" hint="Supprimer">
              <v-icon dark>mdi-minus</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-textarea class="my-2 " rows="4" label="Adresse de livraison" v-model="T_ReadAdrLiv" readonly></v-textarea>
          </v-row>
          <v-row><v-checkbox class="my-0 py-0" v-model="L_defaultAddress" label="Adresse de livraison par défaut" color="primary" readonly></v-checkbox></v-row>
          <v-row><v-file-input class="my-0 py-0" v-model="O_FileAccessMap" label="Sélectionnez un plan d'accès au format PDF..."></v-file-input></v-row>
          <v-row>
            <v-spacer />
            <v-btn :disabled="T_AdrArdentes === '' || !O_FileAccessMap" class="mb-4" color="secondary" @click="Fct_AddFileAM">Joindre</v-btn>
            <v-btn class="mb-4 ml-4" v-if="T_FileAccessMap != ''" color="primary" @click="Fct_ViewFileAM">Ouvrir</v-btn>
          </v-row>
        </div>
        <div class="mt-4">
          <v-row>
            <v-select v-model="T_CondPmt" :items="TT_CondPmt" label="Condition de paiement" style="max-width:50%;" @change="Fct_SelectCondPmt"></v-select>
            <v-btn class="mx-1 ml-8 mt-4" fab dark x-small @click="Fct_AddCondPmt" color="primary" hint="Ajouter">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
            <v-btn v-show="T_CondPmt" class="mx-1 mt-4" fab dark x-small @click="Fct_ModCondPmt" color="primary" hint="Modifier">
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
            <v-btn v-show="T_CondPmt" class="mx-1 mt-4" fab dark x-small @click="Fct_DelCondPmt" color="primary" hint="Supprimer">
              <v-icon dark>mdi-minus</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-text-field class="my-2" label="Condition de paiement" v-model="T_ReadCondPmt" readonly></v-text-field>
          </v-row>
          <v-row><v-checkbox class="my-0 py-0" v-model="L_defaultCondPmt" label="Condition de paiement par défaut" color="primary" readonly></v-checkbox></v-row>
          <v-row><v-file-input class="my-0 py-0" v-model="O_FileChartePresta" label="Sélectionnez une charte prestataire"></v-file-input></v-row>
          <v-row>
            <v-spacer />
            <v-btn class="mb-4" color="secondary" @click="Fct_AddFileChartePresta">Joindre</v-btn>
            <v-btn class="mb-4 ml-4" v-if="T_FileChartePresta != ''" color="primary" @click="Fct_ViewFileChartePresta">Ouvrir</v-btn>
          </v-row>
        </div>
      </v-col>
      <!--<v-col cols="12" md="6">
        <div v-if="T_File != ''">
          <object type="application/pdf" :data="T_File" width="100%" height="600px"></object>
        </div>
      </v-col>-->
    </v-row>
    <popadresse ref="popadr"></popadresse>
    <popcondpmt ref="condpmt"></popcondpmt>
  </v-container>
</template>

<script>
import { MixinPrefs } from "../../mixin/MixinPrefs";
import popadresse from "./gestionAdresse";
import popcondpmt from "./gestionCondPmt";

export default {
  mixins: [MixinPrefs],
  components: { popadresse, popcondpmt },
  props: { T_EditMode: { type: String } },
  data: () => ({
    T_TextIntro: "",
    T_MailObject: "",
    T_MailBody: "",
    T_FileTermsConditions: "",
    T_FileAccessMap: "",
    O_FileTermsConditions: null,
    O_FileAccessMap: null,
    T_File: "",
    L_FileID: 0,
    B_Loaded: false,
    L_id: 0,
    T_AdrArdentes: "",
    TT_ArdArdentes: [],
    TL_IdArdArdentes: [],
    T_ReadAdrLiv: "",
    L_defaultAddress: 0,
    L_id2: 0,
    T_CondPmt: "",
    TT_CondPmt: [],
    TL_CondPmt: [],
    T_ReadCondPmt: "",
    L_defaultCondPmt: 0,
    O_FileChartePresta: null,
    T_FileChartePresta: ""
  }),
  methods: {
    Fct_Loading() {
      // vérifie l'avancement du chargement de la page
      if (!this.B_PrefsLoaded) {
        this.T_Message = "Chargement des préférences";
      } else {
        this.B_Loaded = true;
      }

      if (this.B_Loaded) {
        this.Fct_Launch();
        this.T_Message = "";
      } else {
        setTimeout(this.Fct_Loading, 500);
      }
    },
    Fct_Launch() {
      this.T_TextIntro = this.Fct_PrefsGetString("PrefTextIntro", "");
      this.T_MailObject = this.Fct_PrefsGetString("PrefMailObject", "");
      this.T_MailBody = this.Fct_PrefsGetString("PrefMailBody", "");
      this.Fct_GetAdr();
      this.Fct_GetCondPmt();
      this.Fct_GetFileChartePresta();
    },
    Fct_ModifyTextIntro() {
      this.Fct_PrefsSetString("PrefTextIntro", this.T_TextIntro);
    },
    Fct_ModifyMailObject() {
      this.Fct_PrefsSetString("PrefMailObject", this.T_MailObject);
    },
    Fct_ModifyMailBody() {
      this.Fct_PrefsSetString("PrefMailBody", this.T_MailBody);
    },
    Fct_ViewFileTC() {
      this.T_File = this.T_FileTermsConditions;
      if (this.T_File == "") {
        this.$root.$children[0].IsisInfo("Ce fichier ne semble pas exister", "error");
      }
    },
    Fct_ViewFileAM() {
      this.T_File = this.T_FileAccessMap;
      if (this.T_FileAccessMap !== "") {
        window.open(this.T_FileAccessMap, "_blank");
      } else {
        this.$root.$children[0].IsisInfo("Ce fichier ne semble pas exister", "error");
      }
    },
    Fct_ViewFileChartePresta(){
      this.T_File = this.T_FileChartePresta;
      if (this.T_FileChartePresta !== "") {
        window.open(this.T_FileChartePresta, "_blank");
      } else {
        this.$root.$children[0].IsisInfo("Ce fichier ne semble pas exister", "error");
      }
    },
    Fct_ViewNoFile() {
      this.T_File = "";
      // location.reload();
    },
    /*Fct_AddFileTC() {
        this.B_PrefsAccessDB = true;
        this.Fct_ResetWhenDone();
        this.Fct_PrefsSetFile('PrefFileTC', this.O_FileTermsConditions);
      },*/
    Fct_AddFileAM() {
      this.B_PrefsAccessDB = true;
      this.Fct_ResetWhenDone();
      this.Fct_PrefsSetFile("PrefFileAM_" + this.L_id, this.O_FileAccessMap);
    },
    Fct_AddFileChartePresta() {
      this.B_PrefsAccessDB = true;
      this.Fct_ResetWhenDone();
      this.Fct_PrefsSetFile("PrefFileChartePresta", this.O_FileChartePresta);
    },
    Fct_ResetWhenDone() {
      if (!this.B_PrefsAccessDB) {
        location.reload();
      } else {
        setTimeout(this.Fct_ResetWhenDone, 500);
      }
    },
    Fct_AddAdresse() {
      this.L_id = 0;
      this.$refs.popadr.show(this.L_id);

      this.L_FileID = 0;
      this.T_FileAccessMap = "";
      this.T_File = this.T_FileAccessMap;
    },
    Fct_ModAdresse() {
      this.$refs.popadr.show(this.L_id);
    },
    Fct_DelAdresse() {
      this.$root.$children[0]
        .IsisConfirm("Confirmez-vous la suppression de cette adresse ?")
        .then(O_Response => {
          if (O_Response != null) {
            if (O_Response == true) {
              // Si on a dit oui à l'effacement
              var T_Token = "JWT " + this.$cookies.get("BackEndToken");
              this.$BackEndAPI
                .delete("preferences/" + this.L_id + "/", { headers: { Authorization: T_Token, Accept: "application/json", "Content-Type": "application/json" } })
                .then(O_Response => {
                  if (O_Response != null) {
                    this.Fct_GetAdr();
                  }
                })
                .catch(O_Error => {
                  this.$root.$children[0].IsisInfo(O_Error.message, "error");
                });

              if (this.L_FileID > 0) {
                this.$BackEndAPI
                  .delete("preferences/" + this.L_FileID + "/", { headers: { Authorization: T_Token, Accept: "application/json", "Content-Type": "application/json" } })
                  .then(O_Response => {
                    if (O_Response != null) {
                      this.L_FileID = 0;
                      this.T_FileAccessMap = "";
                      this.T_File = this.T_FileAccessMap;
                    }
                  })
                  .catch(O_Error => {
                    this.$root.$children[0].IsisInfo(O_Error.message, "error");
                  });
              }
            }
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo(O_Error.message, "error");
        });
    },
    Fct_GetAdr() {
      this.T_AdrArdentes = "";
      this.TT_ArdArdentes = [];
      this.TL_IdArdArdentes = [];
      this.T_ReadAdrLiv = "";
      this.L_defaultAddress = 0;
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/?search=Adr_", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            var TO_Data = TO_Response.data;
            if (TO_Data != undefined) {
              for (var L_Index = 0; L_Index < TO_Data.length; L_Index++) {
                this.TT_ArdArdentes.push(TO_Data[L_Index].libelle);
                this.TL_IdArdArdentes.push(TO_Data[L_Index].id);
              }
            }
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_SelectAdrLiv() {
      var index = this.TT_ArdArdentes.indexOf(this.T_AdrArdentes);
      this.L_id = this.TL_IdArdArdentes[index];
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/" + this.L_id + "/", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.T_ReadAdrLiv = TO_Response.data.address + "\n";
            this.T_ReadAdrLiv += TO_Response.data.postal_code + "  " + TO_Response.data.city + "\n";
            this.T_ReadAdrLiv += TO_Response.data.country;
            this.L_defaultAddress = TO_Response.data.default;

            this.L_FileID = this.Fct_PrefsGetID("PrefFileAM_" + this.L_id);
            this.T_FileAccessMap = this.Fct_PrefsGetFile("PrefFileAM_" + this.L_id, "");
            this.T_File = this.T_FileAccessMap;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo(" Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_GetFileChartePresta() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/?search=PrefFileChartePresta", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.L_FileID = this.Fct_PrefsGetID("PrefFileChartePresta");
            this.T_FileChartePresta = this.Fct_PrefsGetFile("PrefFileChartePresta", "");
            this.T_File = this.T_FileChartePresta;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo(" Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_GetCondPmt() {
      this.T_CondPmt = "";
      this.TT_CondPmt = [];
      this.TL_CondPmt = [];
      this.T_ReadCondPmt = "";
      this.L_defaultCondPmt = 0;
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/?search=CondPmt_", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            var TO_Data = TO_Response.data;
            if (TO_Data != undefined) {
              for (var L_Index = 0; L_Index < TO_Data.length; L_Index++) {
                this.TT_CondPmt.push(TO_Data[L_Index].libelle);
                this.TL_CondPmt.push(TO_Data[L_Index].id);
              }
            }
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_SelectCondPmt() {
      var index = this.TT_CondPmt.indexOf(this.T_CondPmt);
      this.L_id2 = this.TL_CondPmt[index];
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/" + this.L_id2 + "/", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.T_ReadCondPmt = TO_Response.data.value;
            this.L_defaultCondPmt = TO_Response.data.default;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo(" Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_AddCondPmt() {
      this.L_id2 = 0;
      this.$refs.condpmt.show(this.L_id2);
    },
    Fct_ModCondPmt() {
      this.$refs.condpmt.show(this.L_id2);
    },
    Fct_DelCondPmt() {}
  },
  mounted() {
    // Le DOM est chargé
    this.Fct_Loading();
  }
};
</script>
